import { combineReducers } from 'redux';

import { reducer as get } from './getModule';
import { reducer as bulkAttachDetach } from './bulkAttachDetachModule';

export default combineReducers({
	bulkAttachDetach,
	get,
});
